import { normalize } from 'normalizr';

import * as schemas from 'schemas';
import { callApi, pageToOffsetParams } from 'utils/api';

export function mailThreadsFetch(page) {
  return callApi(`/mail/threads`, {
    query: {
      ...pageToOffsetParams(page, process.env.KOOTH_PAGE_SIZE)
    }
  })
  .then(json => {
    const { threads, meta }  = json;
    const { result, entities } = normalize(threads, schemas.threadsArraySchema);

    return {threadsIds: result, entities, meta};
  });
}

export function mailThreadMessagesFetch(threadId, page) {
  return callApi(`/mail/threads/${threadId}/messages`, {
    query: {
      ...pageToOffsetParams(page, process.env.KOOTH_PAGE_SIZE)
    }
  })
  .then(json => {
    const { messages, meta }  = json;
    const { result, entities } = normalize(messages, schemas.threadMessagesArraySchema);

    return {threadMessagesIds: result, entities, meta};
  });
}

export function mailMessageTheTeam(text) {
  return callApi('/mail/threads/message-the-team', {
    method: 'POST',
    body: {
      text
    }
  });
}

export function mailThreadMessageUpdate(threadId, threadMessageId, updates) {
  return callApi(`/mail/threads/${threadId}/messages/${threadMessageId}`, {
    method: 'PATCH',
    body: {
      ...updates
    }
  });
}

export function mailThreadMessageCreate(threadId, text) {
  return callApi(`/mail/threads/${threadId}/messages`, {
    method: 'POST',
    body: {
      text
    }
  });
}



/** WEBPACK FOOTER **
 ** ./src/members/state/mail/api.js
 **/